import {
  Component,
  ElementRef,
  ViewChild,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { GlobalApp } from "../../../tools/global";
import { Router, ActivatedRoute } from "@angular/router";
import { InteractivesService } from "../../../api/services";
import { PowerBIService } from "../../../api/services/power-bi.service";
import { SecurityContext } from "@angular/core";
import * as pbi from "powerbi-client";
import * as iframe from "iframe";
import {
  ModifiedInteract,
  UdInteractFilters,
  InteractiveFilter,
  InteractiveBookmark,
  ReportExportDetails,
  InteractReportsEx,
  SubInteractReportExportsEx,
  SubInteractReportExports,
  UserState,
  US_Interactive,
  US_ModifiedInteractive,
  US_Filter,
  US_Bookmark,
  InteractReports,
  US_ReportExport,
  PowerBISettings,
} from "../../../api/models";
import { SubscriptionService } from "../../../api/services/subscription.service";
import {
  ShareInteractiveDialogData,
  ShareInteractiveDialogComponent,
} from "../../../dialogs/share-interactive-dialog/share-interactive-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../../dialogs/DialogResult";
import {
  CopyInteractiveDialogData,
  CopyInteractiveDialogComponent,
} from "../../../dialogs/copy-interactive-dialog/copy-interactive-dialog.component";
import {
  EditInteractiveFilterDialogData,
  EditInteractiveFilterDialogComponent,
} from "../../../dialogs/edit-interactive-filter-dialog/edit-interactive-filter-dialog.component";
import { promise } from "protractor";
import { MessageDialogComponent } from "../../../dialogs/message-dialog/message-dialog.component";
import { ConfirmDialogComponent } from "../../../dialogs/confirm-dialog/confirm-dialog.component";
import {
  InteractMenuDialogData,
  InteractMenuDialogComponent,
} from "../../../dialogs/interact-menu-dialog/interact-menu-dialog.component";
import {
  EditInteractiveBookmarkDialogData,
  EditInteractiveBookmarkDialogComponent,
} from "../../../dialogs/edit-interactive-bookmark-dialog/edit-interactive-bookmark-dialog.component";
import {
  ReportExportDialogData,
  ReportExportDialogComponent,
} from "../../../dialogs/report-export-dialog/report-export-dialog.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UserStateEx } from "../../../api/models-ex/user-state-ex";
import { DeepCopy } from "../../../api/models-ex/deep-copy";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: "powerbi-report-export-start",
  templateUrl: "./powerbi-report-export-start.component.html",
})
export class PowerBiReportExportStart implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private app: GlobalApp,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.app.setFullScreenMode();
    this.route.paramMap.subscribe((params) => {
      const reportInteractiveId = parseInt(params.get("reportInteractiveId"));
      const reportExportId = parseInt(params.get("reportExportId"));
      const reportPage = params.get("reportPage");
      this.router.navigate([
        "report-export-internal-process",
        reportInteractiveId,
        reportExportId,
        reportPage
      ]);
    });
  }
}
